import $ from 'jquery';
import I18n from 'i18n-js';
import 'javascripts/i18n/translations';
I18n.locale = window.I18n.locale;

$(document).on('turbolinks:load', function () {
    let timerKey;
    let searchRequestByKey;
    let delay = 1000;
    let $outgoingName = $('input#outgoing_name');
    let $ingoingName = $('input#ingoing_name');
    let $outgoingWitnessName = $('input#outgoing_witness_name');
    let $ingoingWitnessName = $('input#ingoing_witness_name');
    let $linkName = $('input#link_name');
    let $representativeName = $('input#representative_name');
    let outgoingKey = document.getElementById('outgoing_key');
    let ingoingKey = document.getElementById('ingoing_key');
    let outgoingWitnessKey = document.getElementById('outgoing_witness_key');
    let ingoingWitnessKey = document.getElementById('ingoing_witness_key');
    let linkKey = document.getElementById('link_key');
    let representativeKey = document.getElementById('representative_key');
    let $submitButton = $('input#submit_new_process');

    let resquestName = (cve_empleado, employee_charge) => {
        if (cve_empleado.length > 0) {
            searchRequestByKey = $.ajax({
                url: `/api/v1/employees/get_name/${cve_empleado}`,
                method: 'GET',
                success: (data) => {
                    if (data !== null) {
                        switch (employee_charge) {
                            case 'outgoing_name':
                                $outgoingName.val(data.name);
                                break;
                            case 'outgoing_witness_name':
                                $outgoingWitnessName.val(data.name);
                                break;
                            case 'ingoing_name':
                                $ingoingName.val(data.name);
                                break;
                            case 'ingoing_witness_name':
                                $ingoingWitnessName.val(data.name);
                                break;
                            case 'link_name':
                                $linkName.val(data.name);
                                break;
                            case 'representative_name':
                                $representativeName.val(data.name);
                                break;
                        }
                    }
                },
                error: (error) => {
                    switch (employee_charge) {
                        case 'outgoing_name':
                            $outgoingName.val('');
                            break;
                        case 'outgoing_witness_name':
                            $outgoingWitnessName.val('');
                            break;
                        case 'ingoing_name':
                            $ingoingName.val('');
                            break;
                        case 'ingoing_witness_name':
                            $ingoingWitnessName.val('');
                            break;
                        case 'link_name':
                            $linkName.val('');
                            break;
                        case 'representative_name':
                            $representativeName.val('');
                            break;
                    }
                },
                complete: () => {
                }
            });
        }
    };

    if (outgoingKey !== null) {
        outgoingKey.addEventListener('input', function () {
            let cve_empleado = $(this).val();
            $outgoingName.val('');

            window.clearTimeout(timerKey);
            searchRequestByKey && searchRequestByKey.abort();
            timerKey = window.setTimeout(function () {
                resquestName(cve_empleado, 'outgoing_name');
            }, delay);
        });

        let cve_empleado = $(outgoingKey).val();
        if (cve_empleado !== '') {
            resquestName(cve_empleado, 'outgoing_name');
        }
    }

    if (outgoingWitnessKey !== null) {
        outgoingWitnessKey.addEventListener('input', function () {
            let cve_empleado = $(this).val();
            $outgoingWitnessName.val('');

            window.clearTimeout(timerKey);
            searchRequestByKey && searchRequestByKey.abort();
            timerKey = window.setTimeout(function () {
                resquestName(cve_empleado, 'outgoing_witness_name');
            }, delay);
        });

        let cve_empleado = $(outgoingWitnessKey).val();
        if (cve_empleado !== '') {
            resquestName(cve_empleado, 'outgoing_witness_name');
        }
    }

    if (ingoingKey !== null) {
        ingoingKey.addEventListener('input', function () {
            let cve_empleado = $(this).val();
            $ingoingName.val('');

            window.clearTimeout(timerKey);
            searchRequestByKey && searchRequestByKey.abort();
            timerKey = window.setTimeout(function () {
                resquestName(cve_empleado, 'ingoing_name');
            }, delay);
        });

        let cve_empleado = $(ingoingKey).val();
        if (cve_empleado !== '') {
            resquestName(cve_empleado, 'ingoing_name');
        }
    }

    if (ingoingWitnessKey !== null) {
        ingoingWitnessKey.addEventListener('input', function () {
            let cve_empleado = $(this).val();
            $ingoingWitnessName.val('');

            window.clearTimeout(timerKey);
            searchRequestByKey && searchRequestByKey.abort();
            timerKey = window.setTimeout(function () {
                resquestName(cve_empleado, 'ingoing_witness_name');
            }, delay);
        });

        let cve_empleado = $(ingoingWitnessKey).val();
        if (cve_empleado !== '') {
            resquestName(cve_empleado, 'ingoing_witness_name');
        }
    }

    if (linkKey !== null) {
        linkKey.addEventListener('input', function () {
            let cve_empleado = $(this).val();
            $linkName.val('');

            window.clearTimeout(timerKey);
            searchRequestByKey && searchRequestByKey.abort();
            timerKey = window.setTimeout(function () {
                resquestName(cve_empleado, 'link_name');
            }, delay);
        });

        let cve_empleado = $(linkKey).val();
        if (cve_empleado !== '') {
            resquestName(cve_empleado, 'link_name');
        }
    }

    if (representativeKey !== null) {
        representativeKey.addEventListener('input', function () {
            let cve_empleado = $(this).val();
            $representativeName.val('');

            window.clearTimeout(timerKey);
            searchRequestByKey && searchRequestByKey.abort();
            timerKey = window.setTimeout(function () {
                resquestName(cve_empleado, 'representative_name');
            }, delay);
        });

        let cve_empleado = $(representativeKey).val();
        if (cve_empleado !== '') {
            resquestName(cve_empleado, 'representative_name');
        }
    }

});